import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Dashboard from './dashboard';

ReactDOM.render(<Dashboard />, document.getElementById('root'));
